module.exports = __webpack_public_path__ + "img/Member icon-02.da3acdde.png";